module.exports = __webpack_public_path__ + "img/bx-arranging-active.5bff6dbd.svg";